import {Component, Injector} from '@angular/core';
import {BaseComponent} from '../../base.component';
import {RouteUtil} from '../../../util/route.util';
import {Config} from '../../../common/config';

@Component({
  selector: 'app-about-us',
  standalone: false,
  templateUrl: './about-us.component.html',
  styleUrl: './about-us.component.scss'
})
export class AboutUsComponent extends BaseComponent {
  protected readonly Config = Config;

  constructor(injector: Injector) {
    super(injector);
  }

  openBackClicked() {
    this.router.navigate([RouteUtil.CLIENT_MODULE, RouteUtil.ACCOUNT_COMPONENT]).then();
  }
}
